import { TableCell, TableRow, TextField, Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import React, { useContext, useState, useEffect } from "react";
import { DashboardContext } from "../../../contexts/dashboard.context";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplayIcon from "@mui/icons-material/Replay";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { NumberFormatEuro } from "../../customComponents/number.format.input";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { formatVariants } from "../../../functions";

const styles = (theme) => ({
  dialogContainer: {
    minWidth: 300,
  },
  dialogContent: { marginTop: theme.spacing(8) },
  deletedDish: {
    textDecoration: "line-through",
  },
  spacingLeft: {
    marginLeft: theme.spacing(2),
  },
  iconPadding: {
    padding: 4,
  },
  centeredIcon: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginTop: '200px',
    gap: '40px'
  }
});


const _NumberFormatEuro = React.forwardRef(function _NumberFormatEuro(props, ref) {
  return <NumberFormatEuro {...props} getInputRef={ref} />;
});

export default withStyles(styles)(function RoomDishRow({
  dish,
  classes,
  tableId,
  isEditing,
  handleChangeTotalPrice,
  setScontoTotalPrice,
  accettato
}) {
  const { setDish, getDish, modifyTable, data, getTable, setTable } =
    useContext(DashboardContext);
  const [amount, setAmount] = useState(dish.amount);
  const [price, setPrice] = useState(dish.price);

  useEffect(() => {
    //Serve per aggiornare l'amount dopo che hai ordinato e se aggiorni amount o il prezzo da un altro dispositivo
    setAmount(dish.amount)
    setPrice(dish.price)
  }, [dish.amount, dish.price])

  const i = data.findIndex((res) => (res.tableId || res.deliveryId) === tableId);
  const table = i === -1 ? null : data[i];


  const handleChangeDish = (dishId, value) => {
    const [myDish] = getDish(tableId, dishId);
    setDish(tableId, dishId, { ...myDish, ...value });
  };

  const handleChangeAmount = (dishId, value) => {
    setAmount(value);
    const [myDish] = getDish(tableId, dishId);
    myDish.amount = value;
    setDish(tableId, dishId, { ...myDish });
    handleChangeTotalPrice(undefined, 'dishRow');

    setTimeout(() => {
      modifyTable(table.id, table);
    }, 3000);

  };


  const handleChangePrice = (dishId, value) => {
    setPrice(value);
    const [myDish] = getDish(tableId, dishId);
    myDish.price = value;
    setDish(tableId, dishId, { ...myDish });
    handleChangeTotalPrice(undefined, 'dishRow');

    setTimeout(() => {
      modifyTable(table.id, table);
    }, 3000);
  };


  const deleteItem = (tableId, dishId) => {
    let [myTable] = getTable(tableId);
    if (myTable) {
      const myDishIndex = myTable.reservations
        .map(({ id }) => id)
        .indexOf(dishId);
      if (myDishIndex !== -1) {
        let r = [...myTable.reservations];
        r[myDishIndex].status = "owner_deleted";
        setTable(tableId, { ...myTable, reservations: r });
        setScontoTotalPrice(0);
      }
    }

    setTimeout(() => {
      modifyTable(table.id, table);
    }, 1000);
  };

  const restoreItem = (tableId, dishId) => {
    let [myTable] = getTable(tableId);
    if (myTable) {
      const myDishIndex = myTable.reservations
        .map(({ id }) => id)
        .indexOf(dishId);
      if (myDishIndex !== -1) {
        let r = [...myTable.reservations];
        r[myDishIndex].status = "preparation";

        setTable(tableId, { ...myTable, reservations: r });
      }
    }

    setTimeout(() => {
      modifyTable(table.id, table);
    }, 1000);
  };


  const handleTogglePrinted = (dishId) => {
    const [myDish] = getDish(tableId, dishId);
    const newPrinted = myDish.printed === 1 ? 0 : 1;
    setDish(tableId, dishId, { ...myDish, printed: newPrinted });

    // Salvo la modifica nel tavolo dopo un piccolo delay
    setTimeout(() => {
      modifyTable(table.id, table);
    }, 1000);
  };



  return (
    <TableRow>
      <TableCell scope="row">
        <div className={dish.status === "owner_deleted" ? classes.deletedDish : ""}>
          {dish.status !== "owner_deleted" ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: "1px solid",
                borderColor: "divider", // Usa il colore del bordo del tema
                borderRadius: "50px", // Effetto capsula
                padding: "2px 4px",
                backgroundColor: (theme) => theme.palette.background.paper,
                width: "fit-content", // Si adatta al contenuto
                //opacity: accepted === 0 ? 0.6 : 1, // Feedback visivo se disabilitato
                //pointerEvents: accepted === 0 ? "none" : "auto", // Disabilita click se non accettato
              }}
            >
              <IconButton
                size="small"
                aria-label="reduce"
                onClick={() => handleChangeAmount(dish.id, amount - 1)}
                disabled={amount <= 1 || accettato === 0}
                sx={{ padding: "4px", color: "secondary.main" }}
              >
                <RemoveIcon fontSize="small" />
              </IconButton>

              <Typography
                variant="body2"
                component="span"
                sx={{
                  mx: 1.5, // Margine orizzontale
                  fontWeight: 600,
                  minWidth: "20px", // Evita che il layout salti cambiando numero
                  textAlign: "center",
                }}
              >
                {amount}
              </Typography>

              <IconButton
                size="small"
                aria-label="increase"
                onClick={() => handleChangeAmount(dish.id, amount + 1)}
                // disabled={!dish.id} // Scommenta se serviva
                disabled={accettato === 0}
                sx={{ padding: "4px", color: "primary.main" }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>
          ) : (
            <Typography color="textSecondary" variant="body2" sx={{ fontWeight: 'bold' }}>
              0
            </Typography>
          )}
        </div>

      </TableCell>
      <TableCell>
        <Typography
          className={dish.status === "owner_deleted" ? classes.deletedDish : ""}
          style={{ display: 'flex', alignItems: 'center', gap: '16px', cursor: 'pointer' }}
        >
          <IconButton
            onClick={() => handleTogglePrinted(dish.id)}
            size="small"
            disabled={dish.status === "owner_deleted"}
            sx={{
              border: '1px solid rgba(0,0,0,0.2)',
              backgroundColor: 'rgba(0,0,0,0.05)',
            }}
          >
            {dish.printed === 1 ? (
              <CheckCircleIcon color="primary" style={{ fontSize: '20px' }} />
            ) : (
              <AccessTimeFilledIcon color="warning" style={{ fontSize: '20px' }} />
            )}
          </IconButton>
          {dish.name}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <div
          className={dish.status === "owner_deleted" ? classes.deletedDish : ""}
        >
          {isEditing && dish.status !== "owner_deleted" ? (
            <TextField
              label="Variante"
              margin="normal"
              variant="outlined"
              className={classes.spacingBottom}
              name="variant"
              value={dish.variant || ''}
              onChange={(e) =>
                handleChangeDish(dish.id, {
                  variant: e.target.value,
                })
              }
              multiline
              InputProps={{
                style: {
                  resize: 'none',  // Disabilita il ridimensionamento manuale
                  width: '300px',
                  height: 'fit-content'
                },
              }}
            />
          ) : (
            <div style={{ whiteSpace: 'break-spaces', textAlign: 'right' }}>{formatVariants(dish.variant)}</div>
          )}
        </div>
      </TableCell>
      <TableCell align="right">
        <Typography
          className={dish.status === "owner_deleted" ? classes.deletedDish : ""}
        >
          {dish.note}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <div
          className={dish.status === "owner_deleted" ? classes.deletedDish : ""}
        >
          {isEditing && dish.status !== "owner_deleted" ? (
            <TextField
              label="Prezzo"
              fullWidth
              margin="normal"
              variant="outlined"
              className={classes.spacingBottom}
              name="price"
              InputProps={{
                inputComponent: _NumberFormatEuro,
              }}
              value={dish.price}
              onChange={(e) =>
                handleChangeDish(dish.id, {
                  price: Number(e.target.value),
                })
              }
            />
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
              <IconButton disabled={price <= 0} color="secondary" onClick={() => handleChangePrice(dish.id, price - 0.50)}>
                <RemoveIcon />
              </IconButton>
              {price !== null ? `${(price * amount).toFixed(2).toString().replace('.', ',')} €` : "€"}
              <IconButton color="primary" onClick={() => handleChangePrice(dish.id, price + 0.50)}>
                <AddIcon />
              </IconButton>
            </div>
          )}
        </div>
      </TableCell>
      <TableCell align="center">
        {
          (dish.status === "owner_deleted" ? (
            <IconButton onClick={() => restoreItem(tableId, dish.id)}>
              <ReplayIcon />
            </IconButton>
          ) : (
            <IconButton disabled={accettato === 0} onClick={() => deleteItem(tableId, dish.id)}>
              <DeleteIcon />
            </IconButton>
          ))}
      </TableCell>
    </TableRow>
  );
});
